"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import Toast from "vwa/components/Toast";
import dispatcher from "./../dispatcher";
import {getUserId} from "./../utils/user";
import {getBoundsOfPOI} from "./../utils/poi";

async function setOwner(poiId) {
	if (!poiId) return;
	const userId = getUserId();
	if (!userId) return;
	const response = await api.post("pois/collaborations", {
		_id: poiId,
		collaborations: [{collaborator: userId, privilege: 4}]
	});
	return response.collaborations[0];
}

export default async function uploadPOI(poi) {
	try {
		const response = await api.post("pois", {pois: [poi]});
		const collaboration = await setOwner(response.pois[0]._id);
		dispatcher.dispatch('createPOI', response.pois[0], collaboration);
		dispatcher.dispatch('setMap', {
			bounds: getBoundsOfPOI(response.pois[0]._id).toJSON()
		});
		dispatcher.dispatch('selectPOI', response.pois[0]._id);
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}


// WEBPACK FOOTER //
// ./src/api/uploadPOI.js